export default __webpack_public_path__ + "static/media/litanyofprotection.351e9653.png";